/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TopicsOverviewRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      subjects: this.store.findAll('goals/subject'),
      categories: this.store.findAll('goals/category'),
      goals: this.store.findAll('goals/goal'),
    });
  }
}
